import { render } from "./InvitationPage.vue?vue&type=template&id=01ab8b4a&ts=true"
import script from "./InvitationPage.vue?vue&type=script&lang=ts"
export * from "./InvitationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/System/Users/InvitationPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01ab8b4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01ab8b4a', __exports__)) {
    api.reload('01ab8b4a', __exports__)
  }
  
  module.hot.accept("./InvitationPage.vue?vue&type=template&id=01ab8b4a&ts=true", () => {
    api.rerender('01ab8b4a', render)
  })

}


export default __exports__